import styled from 'styled-components'
import { breakpoints } from '../../constants'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 15px;
	background-color: #f2f2f2;
`

export const ImageContainer = styled.div`
	width: 50%;
	padding: 0 20px 0 0;
	display: block;
	max-width: 350px;

	@media (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
		display: none;
	}
`
